import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.scss'
import App from './App.jsx'
import { Auth0Provider } from '@auth0/auth0-react'
import { getConfig } from './config.js'
import logger from './utils/logger'
// Import i18n (needs to be bundled)
import './i18n'

import TokenProviderBridge from './auth/TokenProviderBridge'

// Set up global error handlers to capture uncaught errors
// Note: ResizeObserver suppression handled in public/index.html (before webpack overlay)
window.addEventListener('error', (event) => {
  logger.error('Uncaught error', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  })
})

// Capture unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  logger.error('Unhandled promise rejection', {
    reason: event.reason
  })
})

// Please see https://auth0.github.io/auth0-react/interfaces/auth0provideroptions.html
// for a full list of the available properties on the provider
const config = getConfig()

const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  ...(process.env.REACT_APP_AUTH0_PERSIST_SESSION === 'true'
    ? { cacheLocation: 'localstorage', useRefreshTokens: true }
    : null),
  authorizationParams: {
    redirect_uri: window.location.origin,
    ...(config.audience ? { audience: config.audience } : null),
  },
}

const root = createRoot(document.getElementById('root'))
root.render(
  <Auth0Provider {...providerConfig}>
    <TokenProviderBridge>
      <App />
    </TokenProviderBridge>
  </Auth0Provider>
)
